import { defineMessages } from 'react-intl';

const messages = defineMessages({
  logoTitle: { id: 'modules-employerThankYouPage-logoLinkTitle' },
  logoTitleEmployer: { id: 'modules-employerThankYouPage-logoLinkTitleEmployer' },
  copyright: { id: 'modules-employerThankYouPage-footer-copyright' },
  termsAndConditions: { id: 'modules-employerThankYouPage-footer-termsAndConditions' },
  privacyPolicy: { id: 'modules-employerThankYouPage-footer-privacyPolicy' },
  qualityAssurance: { id: 'modules-employerThankYouPage-footer-qualityAssurance' },
  legalNotice: { id: 'modules-employerThankYouPage-footer-legalNotice' },
});

export default messages;
